module.exports = __webpack_public_path__ + "e990069c73973843c86fab8058fa6870.fbx";